module.exports = __webpack_public_path__ + "main/assets/public/social-icons/bluesky.0e1f953d3831a379.svg";